import TranslationAiTableFilter from "./translation-ai-table-filter";


const SettingsFilters = {
    TranslationAiTable: TranslationAiTableFilter,
};

export default SettingsFilters;
